import React from 'react'
import { Row } from 'antd'
import styled from 'styled-components'
import PrivateActiveBin from '../../../assets/bin/private_active_1.png'
import PrivateInActiveBin from '../../../assets/bin/private_inactive_1.png'
import PublicActiveBin from '../../../assets/bin/public_active_1.png'
import PublicInActiveBin from '../../../assets/bin/public_inactive_1.png'

export const BinSelectItem = styled.div`
  height: auto;
  border: 1px solid #e3e7ed;
  cursor: pointer;
  margin: 2px;
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
  ${(props) =>
    props.active &&
    `
            border-color: #6ebf4b;
    `}
`

const BinSelect = ({ name, onChange, value, valueSelect }) => {
  return (
    <BinSelectItem
      active={value === valueSelect}
      onClick={() => onChange(valueSelect)}>
      <Row justify="center">
        {valueSelect === '1' && (
          <img
            src={value === valueSelect ? PublicActiveBin : PublicInActiveBin}
            alt=""
            height={45}
            width={45}
          />
        )}
        {valueSelect === '2' && (
          <img
            src={value === valueSelect ? PrivateActiveBin : PrivateInActiveBin}
            alt=""
            height={45}
            width={45}
          />
        )}
      </Row>
      <Row justify="center">
        <span>{name}</span>
      </Row>
    </BinSelectItem>
  )
}

export default BinSelect



// WEBPACK FOOTER //
// ./src/pages/SignupBin/BinSelect/index.js